import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Error500Image from 'atoms/Icons/Error500Image';
import Error501Icon from 'atoms/Icons/Error501Icon';
import Link from 'atoms/NextLink';
import React from 'react';

import s from './Error.module.scss';

const Error500 = () => {
  return (
    <div className={s.Error}>
      <div className={s.Error__status}>
        <Error501Icon />
      </div>
      <div className={s.Error__msg}>Something went wrong</div>
      <Link href="/marketplace">
        <a className={s.Error__back}>
          <ArrowBackIcon className={s.Error__backIcon} />
          Back home
        </a>
      </Link>
      <Error500Image className={s.Error__image} />
    </div>
  );
};

export default Error500;
